export default class Map {
  constructor() {
    this.mapDots = document.querySelectorAll(".js-map-dot");
    this.mapInfos = document.querySelectorAll(".js-map-info");
    this.mapBg = document.querySelector(".js-map-components");

    this.showInfo = this.showInfo.bind(this);
    this.hideAllInfo = this.hideAllInfo.bind(this);

    this.mapDotClick = this.mapDotClick.bind(this);
    this.mapInfoClick = this.mapInfoClick.bind(this);
    this.mapBgClick = this.mapBgClick.bind(this);
  }

  init() {
    this.events();
  }

  events() {
    this.mapDots.forEach(el => {
      el.addEventListener("click", this.mapDotClick);
    });

    this.mapInfos.forEach(el => {
      el.addEventListener("click", this.mapInfoClick);
    });

    if (this.mapBg) this.mapBg.addEventListener("click", this.mapBgClick);
  }

  mapDotClick(e) {
    e.stopPropagation();
    this.showInfo(e);
  }

  mapInfoClick(e) {
    e.stopPropagation();
  }

  mapBgClick(e) {
    e.stopPropagation();
    this.hideAllInfo();
  }

  showInfo(e) {
    this.hideAllInfo();
    var info = e.target.nextElementSibling;
    info.classList.add("is-visible");
  }

  hideAllInfo() {
    this.mapInfos.forEach(el => {
      el.classList.remove("is-visible");
    });
  }

  render() {
    //
  }
}



// WEBPACK FOOTER //
// ./scripts/components/map.js